/**
 * Multi-touch attribution shortcuts.
 */
import { Attribution, ConversionEvent } from "../../features/analytics/attribution";

export class AttributionTracker {
  constructor(public readonly client: Attribution) {}

  /** Record a marketing touchpoint. */
  touchpoint(userId: string, channel: string, properties?: Record<string, unknown>) {
    return this.client.trackTouchpoint({ userId, channel, properties });
  }

  /** Record a conversion that should be attributed. */
  conversion(userId: string, conversionType: ConversionEvent["conversionType"], properties?: Record<string, unknown>) {
    return this.client.recordConversion({ userId, conversionType, properties });
  }

  /** Auto-capture a touchpoint from `utm_*` params + `document.referrer`. */
  captureFromUrl(userId: string) {
    return this.client.captureFromUrl(userId);
  }
}
